import React, { useRef, useState } from 'react';

type InlineTextProps = { value: string; label: string; placeholder?: string; multiline?: boolean; onCommit: (value: string) => void; onCancel: () => void };

export default function InlineText({ value, label, placeholder, multiline, onCommit, onCancel }: InlineTextProps) {
  const [draft, setDraft] = useState(value);
  const cancelled = useRef(false);
  const Field = multiline ? 'textarea' : 'input';
  return (
    <Field
      aria-label={label}
      autoFocus
      className="inline-edit"
      onBlur={() => (cancelled.current ? onCancel() : onCommit(draft.trim()))}
      onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setDraft(event.target.value)}
      onClick={(event: React.MouseEvent) => event.stopPropagation()}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          event.currentTarget.blur();
        } else if (event.key === 'Escape') {
          event.stopPropagation();
          cancelled.current = true;
          event.currentTarget.blur();
        }
      }}
      onPointerDown={(event: React.PointerEvent) => event.stopPropagation()}
      placeholder={placeholder}
      value={draft}
    />
  );
}
